import React from "react";
import "./CardVideoCall.css";

const CardVideoCall = (props) => {
  return <div className="card card-videoCall">{props.children}</div>;
};

export default CardVideoCall;
